const initState = {
	fetching: false,
	fetched: false,
	error: null,
	payload: {},
	saved: false,
	message: null,
	expedition: {},
	isDeleted: false,
};

const expeditionReducer = (state = initState, action) => {
	switch (action.type) {
		case 'EXPEDITION_PENDING':
			return {
				...state,
				fetching: true
			};
		case 'EXPEDITION_REJECTED':
			
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'EXPEDITION_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				payload: action.payload.data,
				error: null,
				saved: false,
				isDeleted: false
			};
		case 'SAVE_EXPEDITION_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'SAVE_EXPEDITION_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false,
				fetched: false
			};
		case 'SAVE_EXPEDITION_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				saved: true
			};
		case 'GET_EXPEDITION_PENDING':
			return {
				...state,
				fetching: true
			};
		case 'GET_EXPEDITION_REJECTED':
			
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'GET_EXPEDITION_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				expedition: action.payload.data,
				error: null,
				saved: false,
			};
		case 'UPDATE_EXPEDITION_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'UPDATE_EXPEDITION_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false,
				fetched: false
			};
		case 'UPDATE_EXPEDITION_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				saved: true
			};
		case 'DELETE_EXPEDITION_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'DELETE_EXPEDITION_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'DELETE_EXPEDITION_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				isDeleted: true
			};
		default:
			return state;
	}
};

export default expeditionReducer;
